module.exports = __webpack_public_path__ + "afaeed2d2f7098a10e450c5ad7f32547.png";